import React, { useState } from "react";

import "../css/LynxStyle.css";

const LoveCalculator = () => {
  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");
  const [result, setResult] = useState(null);

  const CalculateLove = () => {
    if (!name1.trim() || !name2.trim()) {
      return;
    }
    const combined = (name1 + name2).toLowerCase().replace(/[^a-z]/g, "");
    let hash = 0;
    for (let i = 0; i < combined.length; i++) {
      hash = (hash * 31 + combined.charCodeAt(i)) % 100;
    }
    const percentage = combined.length > 0 ? hash : 0;

    let message = "";
    if (percentage >= 90) {
      message = "Soulmates! 💍";
    } else if (percentage >= 70) {
      message = "A match made in heaven! 💞";
    } else if (percentage >= 50) {
      message = "There's real potential here! 💗";
    } else if (percentage >= 30) {
      message = "Could go either way... 🤔";
    } else {
      message = "Maybe just stay friends! 😅";
    }

    setResult({ percentage, message });
  };

  return (
    <div className="container">
      <br />
      <br />
      <h3 className="text-white">💘 Love Calculator</h3>
      <div className="lynx-page-card">
        <form>
          <div className="form-group">
            <label htmlFor="name1" className="text-white">
              Your Name:
            </label>
            <input
              type="text"
              value={name1}
              onChange={(e) => setName1(e.target.value)}
              className="form-control"
              id="name1"
              placeholder="Enter your name"
            />
          </div>
          <div className="form-group mt-3">
            <label htmlFor="name2" className="text-white">
              Their Name:
            </label>
            <input
              type="text"
              value={name2}
              onChange={(e) => setName2(e.target.value)}
              className="form-control"
              id="name2"
              placeholder="Enter their name"
            />
          </div>
          <div className="text-center mt-3">
            <button
              type="button"
              onClick={CalculateLove}
              className="btn-lynx w-100"
            >
              💕 Calculate Love
            </button>
          </div>
        </form>
        {result && (
          <div className="smsgpt text-center mt-3 fs-5">
            {name1} + {name2} = {result.percentage}%
            <br />
            {result.message}
          </div>
        )}
      </div>
      <p className="text-white text-center mt-3">
        <small>For entertainment purposes only 😉</small>
      </p>
    </div>
  );
};

export default LoveCalculator;
